import React, { useState, useEffect } from 'react';
import Header from '../components/Header';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { getProjectNames, createProjectName } from '../services/projectService';

const ProjectNamePage = () => {
  const [title, setTitle] = useState('');
  const [loading, setLoading] = useState(false);
  const [projects, setProjects] = useState([]);

  const loadProjects = async () => {
    try {
      const res = await getProjectNames();
      setProjects(Array.isArray(res.data.data) ? res.data.data : []);
    } catch (err) {
      toast.error('প্রজেক্ট লোড করতে সমস্যা: ' + (err.response?.data?.error || err.message));
    }
  };

  useEffect(() => { loadProjects(); }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!title.trim()) {
      toast.error('প্রজেক্ট নাম প্রয়োজন');
      return;
    }
    setLoading(true);
    try {
      await createProjectName(title.trim());
      toast.success('প্রজেক্ট তৈরি হয়েছে');
      setTitle('');
      loadProjects();
    } catch (err) {
      toast.error('তৈরি করতে সমস্যা: ' + (err.response?.data?.error || err.message));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="game-dashboard">
      <Header />
      <ToastContainer />
      <div className="container py-5">
        <h1 className="main-title">প্রজেক্ট নাম</h1>
        <form onSubmit={handleSubmit} className="mb-4">
          <div className="row g-3">
            <div className="col-md-6">
              <input
                type="text"
                className="form-control rounded-pill"
                placeholder="প্রজেক্টের নাম লিখুন"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                disabled={loading}
              />
            </div>
            <div className="col-md-2">
              <button type="submit" className="btn btn-register rounded-pill px-4" disabled={loading}>
                সংরক্ষণ
              </button>
            </div>
          </div>
        </form>

        <div className="card shadow-lg p-4">
          <h2 className="text-center mb-4 gradient-text">প্রজেক্ট তালিকা</h2>
          {projects.length === 0 ? (
            <div className="alert alert-warning">কোনো প্রজেক্ট পাওয়া যায়নি।</div>
          ) : (
            <ul className="list-group">
              {projects.map(p => (
                <li key={p._id} className="list-group-item d-flex justify-content-between align-items-center">
                  {p.title}
                  <span className="badge bg-secondary">{new Date(p.createdAt).toLocaleDateString()}</span>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProjectNamePage;
